import MkuDrawer from './src/drawer';

MkuDrawer.install = function (Vue) {
  Vue.component(MkuDrawer.name, MkuDrawer);
};

export default MkuDrawer;
